$(function () {
    let inputEvent = 'touchend' in document.documentElement ? 'touchend' : 'click';

    if (['closed', 'open'].indexOf(Cookies.get('SidebarStatus')) === -1) {
        Cookies.set('SidebarStatus', 'open');
    }

    $(document).on(inputEvent, '#show_hide', function () {
        if ($(this).hasClass('active')) {
            $('.sidebar').addClass('sidebar-small');
            $(this).removeClass('active');
            Cookies.set('SidebarStatus', 'closed');
        } else {
            $('.sidebar').removeClass('sidebar-small');
            $(this).addClass('active');
            Cookies.set('SidebarStatus', 'open');
        }
    });

    let overlay_menu_active = function (elem) {
        $(elem).closest('.overlay_menu').addClass('active');
        $('.overlay_menu_section').addClass('overlay_menu_active');
        return false;
    };

    let overlay_menu_notactive = function () {
        $('.overlay_menu').removeClass('active');
        $('.overlay_menu_section').removeClass('overlay_menu_active');
        return false;
    };

    $(document).on(inputEvent, '.overlay_menu > span', function (event) {
        event.preventDefault();
        overlay_menu_notactive();
        overlay_menu_active($(this));
        return false;
    });

    $(document).on(inputEvent, '.overlay_menu_back', function () {      // Applied on the back button
        overlay_menu_notactive();
    });

    let moveMenuContent = function (elem, _pos, _time, _roundborder) {       // Parameters Applied on mobile-menu page to give position , border-radius , and animation
        $(elem).animate({left: _pos, borderTopLeftRadius: (_roundborder ? 30 : 0)}, _time);
    }

    $(document).on(inputEvent, '#mymove', function (event) {             // Applied when mobile-burger menu is clicked to move back and forth the page
        event.preventDefault();
        moveMenuContent('#move', 310, 500, true);                       // Applied when mobile-burger menu is clicked to move slide-left
        $('#mask').css({display: 'none'});
        $('#play_it').addClass('active');
        return false;
    });

    $(document).on(inputEvent, '#mymenu', function (event) {
        event.preventDefault();
        moveMenuContent('#move', 0, 500, false);                        // Applied when mobile-burger menu is clicked to move slide-right
        $('#mask').css({display: 'block'});
        $('#play_it').removeClass('active');
        return false;
    });
});

$(window).resize(function () {
    let viewportWidth = $(window).width();
    if (viewportWidth < 768) {
        $(".section").removeClass("section").addClass("container");
        $('.sidebar-item-link > span').show();
        $('.sidebar-submenu-item-link > span').show();
    }
});

$(function () {
    $('.sidebar-item-link').click(function (e) {
        let $subMenu = $(this).parents('.sidebar-item').find('.sidebar-submenu');

        if ($subMenu.length > 0) {
            e.preventDefault();
            $('.sidebar-item-link').hide();
            $subMenu.removeClass('tw-hidden');
            $('.sidebar-label').hide();
        }
    });

    $('.sidebar-submenu-backlink').click(function (e) {
        e.preventDefault();
        $('.sidebar-submenu').addClass('tw-hidden');
        $('.sidebar-item-link').show();
        $('.sidebar-label').show();
    });

    $('.change-nav-items').click(function (e) {
        // Ist dieser Tab bereits aktiv, navigiert der Link wie gewohnt zum Dashboard.
        if ($(this).hasClass('change-nav-items-active')) {
            return;
        }

        // Erster Klick auf einen inaktiven Tab: nur die Menüpunkte dieses Bereichs
        // einblenden, ohne zum Dashboard zu navigieren. Erst ein weiterer Klick auf
        // den dann aktiven Tab führt zum Dashboard.
        e.preventDefault();

        let activeNav = $(this).data('nav');

        // Eventuell geöffnete Submenus auf die oberste Ebene zurücksetzen
        $('.sidebar-submenu').addClass('tw-hidden');
        $('.sidebar-item-link').show();
        $('.sidebar-label').show();

        // Aktiven Tab umschalten
        $('.change-nav-items').removeClass('change-nav-items-active');
        $(this).addClass('change-nav-items-active');

        // Menüpunkte des gewählten Bereichs zeigen, den anderen ausblenden
        $('.works-items, .hr-items').hide();
        $('.' + activeNav + '-items').show();
    });
});
